/**
 * Exchange a bridge refresh token for new access + refresh tokens (POST /api/bridges/tokens/refresh).
 */

export interface RefreshBridgeTokensResult {
  token: string;
  refreshToken: string;
  workspaceId: string;
  tokenId: string;
}

export async function refreshBridgeTokens(params: {
  apiUrl: string;
  workspaceId: string;
  refreshToken: string;
}): Promise<RefreshBridgeTokensResult | null> {
  const base = params.apiUrl.replace(/\/$/, '');
  const url = `${base}/api/bridges/tokens/refresh`;
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        workspaceId: params.workspaceId,
        refreshToken: params.refreshToken,
      }),
    });
    if (!res.ok) return null;
    const data = (await res.json()) as {
      token?: string;
      refreshToken?: string;
      workspaceId?: string;
      tokenId?: string;
    };
    if (typeof data.token !== 'string' || typeof data.refreshToken !== 'string') return null;
    return {
      token: data.token,
      refreshToken: data.refreshToken,
      workspaceId: typeof data.workspaceId === 'string' ? data.workspaceId : params.workspaceId,
      tokenId: typeof data.tokenId === 'string' ? data.tokenId : '',
    };
  } catch {
    return null;
  }
}
